import { all, call, put, takeLatest } from "redux-saga/effects";
import { POST_TINH_TRANG_NO } from "actions/DoiTinhTrangNo/actionTypes";
import {
  postDoiTinhTrangNoSuccess,
  postDoiTinhTrangNoFailure,
} from "actions/DoiTinhTrangNo";
import DoiTinhTrangNoApi from "service/doiTinhTrangNoApi";
import { pushNotification } from "utils/notifications";

function* postDoiTinhTrangNo(action) {
  try {
    const response = yield call(
      DoiTinhTrangNoApi.postDoiTinhTrangNo,
      action.dataPost
    );
    if (response.ok) {
      yield put(postDoiTinhTrangNoSuccess(response.data));
      pushNotification(response.data.Message, "success", "TOP_CENTER", 2000);
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(postDoiTinhTrangNoFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(postDoiTinhTrangNoFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(POST_TINH_TRANG_NO, postDoiTinhTrangNo);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
